import clsx from 'clsx'
import { useInView } from 'react-hook-inview'

interface Props extends React.HTMLAttributes<HTMLHeadingElement> {}

export default function AnimateInView({ className, children, ...rest }: Props) {
  const [ref, isVisible] = useInView({
    unobserveOnEnter: true
  })

  return (
    <div ref={ref} className={clsx(isVisible ? 'opacity-100 animate-fade-left' : 'opacity-0', 'animate-once', className)} {...rest}>
      {children}
    </div>
  )
}
